export const showElement = (toShow) => {
    return toShow === true ? {} : { display: 'none' };
};
